/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';

export const StyledButtonsWrapper = styled.li`
  display: flex;
  flex-direction: column;
  
  &.hide {
    display: none;
  }
  
  &.last div {
    margin-bottom: 0;
  }
`;

export const StyledButtonsTitle = styled.h4`
  margin-top: 0;
  margin-bottom: 0;
  font-weight: 400;
`;

export const StyledButtonsContainer = styled.div`
  display: flex;
  justify-content: space-evenly;
  flex-wrap: wrap;
  margin-top: 10px;
  margin-bottom: 10px;
`;
